import React, { Component } from 'react';
import ReactTypingEffect from 'react-typing-effect';
import Social from '../components/Social'
import profileImage from '../images/profile-image-gray.png';

class Home extends Component {
  render() {
    return (
      <div className="condiv home">
        <img src={profileImage} className="profile-image" alt="profile"></img>
        {/*<ReactTypingEffect className="typingeffect" text={['I am Temitayo Adeleke','I am a web developer']} speed={100} eraseDelay={700}/>*/}
        <div className="heading">
          <h1 className="heading-primary">
            <span className="heading-primary--name">Temitayo Adeleke</span>
            <span className="heading-primary--title"><strong>Full-Stack Web Developer</strong></span>
          </h1>
          <span className="heading-skills"> React | JavaScript | CSS | SASS | HTML | Ruby on Rails | Ruby | WordPress | SQL</span>
        </div>
        <Social />
      </div>
    )
  }
}

export default Home;
